import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import useGoStreaksClick from '@stencil/hotels-hooks/src/useGoStreaksClick';

import HappyAngleRightIcon from '@stencil/icons/src/HappyAngleRightIcon/HappyAngleRightIcon';
import HappyGoStayLogoNew from '@stencil/icons/src/HappyGoStayLogoNew/HappyGoStayLogoNew';

import GoStreakCircleProgress from '@stencil/gi-components/src/GoStreakCircleProgress/GoStreakCircleProgress';

import {detailsPagePushGaThunk} from '@stencil/hotels-ga/src';
import {DetailsGAClickEventActions} from '@stencil/hotels-config/src/config/ga-config';

import * as S from './GoStreakDetails.styles';

const GoStreakDetails = ({streaksInfo}) => {
  const dispatch = useDispatch();
  const [onGoStreaksClickCta] = useGoStreaksClick(streaksInfo, true);

  useEffect(() => {
    if (!streaksInfo?.is_gostreaks_active) {
      return null;
    }

    dispatch(
      detailsPagePushGaThunk({
        eventCategory: DetailsGAClickEventActions.goStreaks.category,
        eventAction: DetailsGAClickEventActions.goStreaks.action.bannerViewed,
        eventLabel: `c_${streaksInfo?.completed_bookings}|p_${
          streaksInfo?.in_progress_bookings || 0
        }`,
      }),
    );
  }, [streaksInfo]);

  const onGoStreaksClick = () => {
    dispatch(
      detailsPagePushGaThunk({
        eventCategory: DetailsGAClickEventActions.goStreaks.category,
        eventAction: DetailsGAClickEventActions.goStreaks.action.bannerClicked,
        eventLabel: `c_${streaksInfo?.completed_bookings}|p_${
          streaksInfo?.in_progress_bookings || 0
        }`,
      }),
    );
    onGoStreaksClickCta();
  };

  if (
    !streaksInfo?.is_gostreaks_active ||
    !streaksInfo?.page_details?.hotel_details?.show_tracker
  ) {
    return null;
  }

  return streaksInfo?.completed_bookings <= streaksInfo?.max_bookings ? (
    <S.GoStreakDetailsWrapper>
      <S.GoStreakDetailsContentWrapper onClick={onGoStreaksClick}>
        <S.InnerLeftWrapper>
          <GoStreakCircleProgress
            strokeWidth="4"
            sqSize="32"
            inProgressBookings={streaksInfo.in_progress_bookings}
            completedBookings={streaksInfo.completed_bookings}
            maxBookings={streaksInfo.max_bookings}
            showTracker={streaksInfo?.page_details?.hotel_details?.show_tracker}
          />
        </S.InnerLeftWrapper>
        <S.InnerRightWrapper>
          <div className="textWrapper">
            <p className="headerText">{streaksInfo?.page_details?.hotel_details?.title}</p>
            <p className="descText">{streaksInfo?.page_details?.hotel_details?.subtitle}</p>
          </div>
          <HappyAngleRightIcon width="1rem" height="1.2rem" fill="#222B45" />
        </S.InnerRightWrapper>
      </S.GoStreakDetailsContentWrapper>
    </S.GoStreakDetailsWrapper>
  ) : null;
};

export default GoStreakDetails;
